import { call, fork, put, select, takeEvery } from 'redux-saga/effects';
import { v4 as uuidv4 } from 'uuid';
import {
	EMAIL_RESEND,
	EMAIL_VERIFY,
	GET_FORM_INFO,
	setFormInfoAction,
	setIsFormLoadingAction,
	setIsFormSendingAction,
} from './actions';
import { emailResendRequest, emailVerifyRequest, getEmailVerifyInfoRequest } from '../../api/requests';
import { REQUEST_ERROR_MESSAGE } from './constants';
import { errorHandler } from '../../api/utils';
import { getUserInfoSelector } from './selectors';
import { setUserInfoAction } from '../profile/actions';
import { getLocalStorageItem, setLocalStorageItem } from '../../utils/localStorage';
import { notificationInit } from '../../modules/notifications/actions';
import { DISMISS_TIME } from '../../api/constants';

export function* getFormInfoSaga({ payload: redirect }) {
	try {
		yield put(setIsFormLoadingAction(true));

		const { data, message } = yield call(getEmailVerifyInfoRequest);

		if (data) {
			if (data.email_verified_at) {
				const user_data = getLocalStorageItem('user_data');

				setLocalStorageItem('user_data', { ...user_data, email_verified_at: data.email_verified_at });

				if (!user_data.accepted_terms_at) {
					redirect('/accept-terms');
				} else if (!user_data.filled_tax_at) {
					redirect('/company-accreditation');
				} else if (!user_data.isCompanyAccredited) {
					redirect('/company/accredited');
				} else {
					redirect('/home/information');
				}
			} else {
				yield put(setFormInfoAction(data));
			}
		} else {
			throw new Error(message || REQUEST_ERROR_MESSAGE);
		}
	} catch (error) {
		yield fork(errorHandler, error);
	} finally {
		yield put(setIsFormLoadingAction(false));
	}
}

export function* emailResendSaga({ payload: redirect }) {
	try {
		yield put(setIsFormSendingAction(true));

		const { data, toast, message } = yield call(emailResendRequest);

		if (data) {
			if (toast) {
				yield put(
					notificationInit({
						id: uuidv4(),
						dismissAfter: DISMISS_TIME,
						...toast,
					}),
				);
			}
			if (data.email_verified_at) {
				const userInfo = yield select(getUserInfoSelector());

				yield put(setUserInfoAction({ ...userInfo, email_verified_at: data.email_verified_at }));

				const user_data = getLocalStorageItem('user_data');

				setLocalStorageItem('user_data', { ...user_data, email_verified_at: data.email_verified_at });

				if (!user_data.accepted_terms_at) {
					redirect('/accept-terms');
				} else if (!user_data.filled_tax_at) {
					redirect('/company-accreditation');
				} else if (!user_data.isCompanyAccredited) {
					redirect('/company/accredited');
				} else {
					redirect('/home/information');
				}
			} else {
				yield put(setFormInfoAction(data));
			}
		} else {
			throw new Error(message || REQUEST_ERROR_MESSAGE);
		}
	} catch (error) {
		yield fork(errorHandler, error);
	} finally {
		yield put(setIsFormSendingAction(false));
	}
}

export function* emailVerifySaga({ payload: { id, hash, redirect } }) {
	try {
		const { data, message } = yield call(emailVerifyRequest, id, hash);

		if (data) {
			if (data.email_verified_at) {
				const userInfo = yield select(getUserInfoSelector());

				yield put(setUserInfoAction({ ...userInfo, email_verified_at: data.email_verified_at }));

				const user_data = getLocalStorageItem('user_data');

				setLocalStorageItem('user_data', { ...user_data, email_verified_at: data.email_verified_at });

				if (!user_data.accepted_terms_at) {
					redirect('/accept-terms');
				} else if (!user_data.filled_tax_at) {
					redirect('/company-accreditation');
				} else if (!user_data.isCompanyAccredited) {
					redirect('/company/accredited');
				} else {
					redirect('/home/information');
				}
			} else {
				yield put(setFormInfoAction(data));
			}
		} else {
			throw new Error(message || REQUEST_ERROR_MESSAGE);
		}
	} catch (error) {
		yield fork(errorHandler, error);
	}
}

export default function* emailVerifyContainerSaga() {
	yield takeEvery(GET_FORM_INFO, getFormInfoSaga);
	yield takeEvery(EMAIL_RESEND, emailResendSaga);
	yield takeEvery(EMAIL_VERIFY, emailVerifySaga);
}
